import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent, SohoBusyIndicatorDirective } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';
import { SohoModalDialogService } from 'ids-enterprise-ng';
import { Router, NavigationExtras } from "@angular/router";
import { StaffSecurityRoleData } from '../models/cm-model';
@Component({
  selector: 'app-edit-access',
  templateUrl: './edit-access.component.html',
  styleUrls: ['./edit-access.component.css']
})
export class EditAccessComponent implements OnInit {
  showBusy = true;
  Message = "Loading...";
  @ViewChild(SohoDataGridComponent) datagrid!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  public data!: any[];
  public grid_Columns!: SohoDataGridColumn[];
  userData = new UserData();
  public GrdRequests: any;
  emailAddress!: string;
  
  constructor(private capacityModelService: CapacityModelService,
    private authhelper: AuthHelper,
    private modalService: SohoModalDialogService,
    private ngZone: NgZone,
    private router: Router,) { }
    
  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined || this.userData.SecurityroleDescription == "") {  
      this.authhelper.setUserRoleAndLoginDetails();    
        
    }
    this.emailAddress = this.userData.Email;
    this.GetRequestDetails();
  }
  GetRequestDetails() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
    this.capacityModelService.GetAccessDetails(this.userData.Email).subscribe(
      staffsecurutyrole => {
        this.data = staffsecurutyrole;
        this.grid_Columns = this.gridColumns;
        if (this.data != null) {
          this.GrdRequests = $("#Requestdatagrid").datagrid().data();
          this.GrdRequests.datagrid.renderRows();
          this.stop();
        }
      },
      (error: Response) => {
        console.log(error);
        this.stop();
      }
    );
  }
  onClick(args: any) {
    console.log(args);
    localStorage.setItem("uniqueid", args["0"].item.uniqueid);
    let navigationExtras: NavigationExtras = {
      queryParams: {
        uniqueid: args["0"].item.uniqueid
      }
    };
    this.ngZone.run(() => this.router.navigate(["EditAccessController"], navigationExtras)).then();
  }
  onselectionChanged(args: any) {
    console.log(args);
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }
  // Cancel() {
  //   $("#divAddProject").removeClass("is-selected");
  //   this.router.navigate(["AccessController"]);
  // }
  gridColumns = [
    {
      id: "edit",
      name: "Edit",
      field: "edit",
      icon: 'edit',
      align: "center",
      sortable: false,
      formatter: Soho.Formatters.Button,
      click: (e: any, args: any) => this.onClick(args)
     },
    {
      id: "securityroledescription",
      name: "Role",
      field: "securityroledescription",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "staffid",
      name: "Staff ID",
      field: "staffid",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "emailaddress",
      name: "Email ID",
      field: "emailaddress",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "createdby",
      name: "Created By",
      field: "createdby",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "created",
      name: "Created On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    },
    {
      id: "active",
      name: " Status",
      field: "active",
      hidden: true,
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "uniqueid",
      name: "Unique ID",
      field: "uniqueid",
      hidden: true,
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
  ];

}
